/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { smoothScrollTo } from "./smoothScrollTo";
import { scroll_to_top } from "./smoothScrollToTopBtn";
import { setScrollTrigger } from "./setScrollTrigger";
import { setSplash } from "./setSplash";
// import { setMegaMenuNav, removeClassMegaOpen } from "./setMegaMenuNav";
// import { setMobileBtn } from "./setMobileBtn";
// import { setHeaderTransform } from "./setHeaderTransform";
import { tabSelecterHover } from "./setTabSelecter";
import "./setSlider";


/**
 * Do modules.
 */
const modules = () => {
  smoothScrollTo()
  scroll_to_top()
  setScrollTrigger()
  setSplash()
  // setMegaMenuNav()
  // setMobileBtn()
  // removeClassMegaOpen()
  // setHeaderTransform()
  // tabSelecterHover()
};

export { modules };
